import React, { useContext, useEffect } from "react";
import Input_form from "../components/Input_form";
const Addparking = () => {

  return (
    <div className="w-full h-auto bg-lime-100">
      <Input_form />
    </div>
  );
};

export default Addparking;
